var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 13.334L17.5 10.0007M17.5 10.0007L14.1667 6.66732M17.5 10.0007H5.83333M10.8333 13.334V14.1673C10.8333 14.8304 10.5699 15.4662 10.1011 15.9351C9.63226 16.4039 8.99637 16.6673 8.33333 16.6673H5C4.33696 16.6673 3.70107 16.4039 3.23223 15.9351C2.76339 15.4662 2.5 14.8304 2.5 14.1673V5.83398C2.5 5.17094 2.76339 4.53506 3.23223 4.06622C3.70107 3.59738 4.33696 3.33398 5 3.33398H8.33333C8.99637 3.33398 9.63226 3.59738 10.1011 4.06622C10.5699 4.53506 10.8333 5.17094 10.8333 5.83398V6.66732",
    stroke: "#08090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutBlack);
export default __webpack_public_path__ + "static/media/logout_black.bdac0e85e486320022296eaf8b3ec656.svg";
export { ForwardRef as ReactComponent };